import { SearchableDropdownValue } from '../Components/Home/Home.dataparser';

export interface ProductsCheckbox {
  checked: boolean;
  value: string;
  label: string;
}

export function parseProducts(
  customerProducts: Array<string> | undefined | null,
  rawProducts: { [key: string]: string } | null,
): Array<ProductsCheckbox> {
  if (customerProducts && rawProducts) {
    return customerProducts
      .filter((product: string) => {
        return !!rawProducts[product];
      })
      .map(
        (product: string): ProductsCheckbox => {
          return {
            checked: false,
            value: product,
            label: rawProducts[product],
          };
        },
      );
  }

  return [];
}

export function parseDates(
  datesFromCustomer: { [key: string]: string } | undefined,
): Array<SearchableDropdownValue> {
  if (datesFromCustomer) {
    const availableDates: Array<SearchableDropdownValue> = [];

    // Will iterate trough pair object and will create formated array for the dropdown.
    for (let key in datesFromCustomer) {
      if (Object.prototype.hasOwnProperty.call(datesFromCustomer, key)) {

        // Restricts minimum date to 2016
        if(Number(key.split("-")[0]) >= 2016) {
          availableDates.push({
            label: datesFromCustomer[key],
            value: key,
          });
        }
        
      }
    }

    return availableDates;
  }

  return [];
}

export const dateToUTC = (date: Date) => {
  return new Date(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds(),
  );
};
